module.exports = __webpack_public_path__ + "fonts/OpenSans-ExtraBoldItalic.61f91fc4.ttf";